"use strict";

var _classCallCheck = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPermission = exports.Permission = exports.Role = exports.Mode = void 0;

var jwt_decode_1 = __importDefault(require("jwt-decode"));

var permissionEnums_1 = require("./permissionEnums");

Object.defineProperty(exports, "Mode", {
  enumerable: true,
  get: function get() {
    return permissionEnums_1.Mode;
  }
});
Object.defineProperty(exports, "Role", {
  enumerable: true,
  get: function get() {
    return permissionEnums_1.Role;
  }
});
Object.defineProperty(exports, "Permission", {
  enumerable: true,
  get: function get() {
    return permissionEnums_1.Permission;
  }
});

var permissionData_1 = require("./permissionData");

var UserPermission = /*#__PURE__*/function () {
  function UserPermission() {
    var _this = this;

    var userToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    _classCallCheck(this, UserPermission);

    this.decodedToken = "";
    this.roles = [];
    this.mode = ""; // utility function (get key by value)

    this.toEnum = function (aEnum, value) {
      return aEnum[value];
    }; // @description: goes through all roles & permission json,
    //  if callback() (param) returns true it will break loop
    //  otherwise it iterates through all.


    this.iteratePermissions = function (permission, callBack) {
      var _iterator = _createForOfIteratorHelper(_this.roles),
          _step;

      try {
        outer: for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var userRole = _step.value;
          var permissionsToCheck = permissionData_1.rolesJSON[userRole];

          var _iterator2 = _createForOfIteratorHelper(permissionsToCheck),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var assignedPermission = _step2.value;
              if (callBack(assignedPermission)) break outer;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    this.modeBlocksPermission = function (permissionToFind) {
      var _a;

      return ((_a = permissionData_1.modesData[permissionEnums_1.Mode[_this.mode]]) === null || _a === void 0 ? void 0 : _a.indexOf(permissionToFind)) > -1 || false;
    };

    this.setToken(userToken);
  } // utility function


  _createClass(UserPermission, [{
    key: "decodeToken",
    value: function decodeToken(userToken) {
      this.decodedToken = (0, jwt_decode_1.default)(userToken);
      var _this$decodedToken = this.decodedToken,
          _this$decodedToken$ro = _this$decodedToken.roles,
          roles = _this$decodedToken$ro === void 0 ? [] : _this$decodedToken$ro,
          _this$decodedToken$mo = _this$decodedToken.mode,
          mode = _this$decodedToken$mo === void 0 ? "" : _this$decodedToken$mo;
      this.roles = roles.map(function (role) {
        return permissionEnums_1.Role[role];
      });
      this.mode = mode;
    }
  }, {
    key: "setToken",
    value: function setToken(userToken) {
      if (!!userToken && userToken.length > 0) {
        this.decodeToken(userToken);
        this.token = userToken;
      } else {
        this.token = undefined;
        this.roles = [permissionEnums_1.Role["Unregistered User"]];
        this.mode = "";
      }

      return this;
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.token;
    } // can pass the programmatic name or enum (number)

  }, {
    key: "has",
    value: function has(permissionToFind) {
      var _this2 = this;

      var hasPermission = false;
      this.iteratePermissions(permissionToFind, function (assignedPermission) {
        var found = false;

        var permissionBlocked = _this2.modeBlocksPermission(assignedPermission);

        if (assignedPermission === permissionToFind && !permissionBlocked) {
          found = hasPermission = true;
        }

        return found;
      });
      return hasPermission;
    }
  }, {
    key: "list",
    value: function list(displayEnumsValues) {
      var _this3 = this;

      var allPermission = [];
      this.iteratePermissions(undefined, function (assignedPermission) {
        var permissionBlocked = _this3.modeBlocksPermission(assignedPermission);

        var alreadyAdded = allPermission.indexOf(assignedPermission) > -1;
        !alreadyAdded && !permissionBlocked && allPermission.push(assignedPermission);
      });
      return displayEnumsValues ? allPermission : allPermission.map(function (perm) {
        return _this3.toEnum(permissionEnums_1.Permission, perm);
      });
    }
  }, {
    key: "getUserRoles",
    value: function getUserRoles() {
      var userToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (!this.roles && !!userToken.length) {
        this.decodeToken(userToken);
      }

      return this.roles;
    }
  }, {
    key: "getUserMode",
    value: function getUserMode() {
      var userToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (!this.mode && !!userToken.length) {
        this.decodeToken(userToken);
      }

      return this.mode;
    }
  }]);

  return UserPermission;
}();

exports.UserPermission = UserPermission;